import * as React from "react";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";

import ExpandedStepIcon from "components/icons/ExpandedStepIcon";
import InactiveIcon from "components/icons/InactiveIcon";
import StepCompletedIcon from "components/icons/StepCompletedIcon";
import CircleNumber from "components/products/CircleWithNumber";
import { GettingStartedLayout } from "components/products/GettingStartedLayout";
import { LicenseData } from "domain/licenses";
import { OnboardingProductType } from "domain/onboardings";
import { OnboardingImage, SoftwarePackage, Versions } from "domain/softwarePackages";
import { StoreState } from "store";

const mapState = (state: StoreState) => ({
    theme: state.themeReducer.theme,
});

interface Props {
    licenses: Versions[];
    fetchedLicenses: LicenseData[];
    fetchedSoftwarePackages?: SoftwarePackage[];
    saveBmdeOnboarded: (onboarded: boolean) => void;
    showBmpSetup: boolean;
    saveLastCompletedStep: (step: string) => void;
    fetchedOnboardingImages: OnboardingImage[];
}

const connector = connect(mapState);

const GettingStarted = (props: Props & ConnectedProps<typeof connector>): JSX.Element => {
    const { t } = useTranslation();
    return (
        <>
            <GettingStartedLayout
                product={OnboardingProductType.BMDE}
                visible={true}
                footerVisibility={false}
                extraHeaderText={t("Onboarding.bmde.productTitle")}
                title={t("Onboarding.gettingStartedFlow.title")}
                description={t("Onboarding.bmde.gettingStarted.description")}
                licenses={props.licenses}
                fetchedLicenses={props.fetchedLicenses}
                fetchedSoftwarePackages={props.fetchedSoftwarePackages}
                saveBmdeOnboarded={props.saveBmdeOnboarded}
                showBmpSetup={props.showBmpSetup}
                saveLastCompletedStep={props.saveLastCompletedStep}
                fetchedOnboardingImages={props.fetchedOnboardingImages}
            />
        </>
    );
};

export default connector(GettingStarted);

export function displayStepCompletionIcon(
    menuExpanded: boolean,
    stepCompleted: boolean,
    step: number,
    stepActive: boolean,
    stepCompletionColor: string,
    whiteColor: string,
    expandedIconBackgroundColor: string,
    inactiveIconColor: string
) {
    return stepCompleted ? (
        <StepCompletedIcon color={stepCompletionColor} checkMarkColor={whiteColor} />
    ) : menuExpanded ? (
        <ExpandedStepIcon color={expandedIconBackgroundColor} />
    ) : stepActive ? (
        <CircleNumber number={step} subStep={false} />
    ) : (
        <InactiveIcon color={inactiveIconColor} step={step} />
    );
}
